import React from 'react'
import { Button, Grid } from '@mui/material'
import ReactModal from 'react-modal'
import { useTranslation } from 'react-i18next'
import { useAppNavigate } from '../../../context/AppContext'
import Logo from '../../../assets/images/logo_bg.png'
import './DaysOffModal.scss'
import { getStorageKey } from '../../../utils/appType'

type Props = {
  isOpen: boolean
  setIsOpen?: (isOpen: boolean) => void
}
const c = 'days-off-modal'

const DaysOffModal = (props: Props) => {
  const { t } = useTranslation()
  const navigate = useAppNavigate()
  const generalInfo = JSON.parse(
    localStorage.getItem(getStorageKey('info')) || '{}',
  )

  return (
    <ReactModal
      shouldCloseOnOverlayClick
      className='days-off-modal-container'
      isOpen={props.isOpen}
      onRequestClose={() => {
        props.setIsOpen?.(false)
        navigate('/')
      }}
    >
      <div className={c}>
        <div className={`${c}-header`}>
          <div className={`${c}__header-image`}>
            <img src={Logo} alt='logo' height={100} width={100} />
          </div>
        </div>
        <div className={`${c}__content`}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className={`${c}__content-text`}>{generalInfo?.dayOff}</div>
            </Grid>
          </Grid>
          <div className={`${c}__content-submit`}>
            <Button
              variant='contained'
              onClick={() => {
                navigate('/')
                props.setIsOpen?.(false)
              }}
              sx={{
                backgroundColor: 'var(--color-primary)',
                textTransform: 'none',
                fontWeight: 'bold',
                width: '100%',
                '&:hover': { backgroundColor: 'var(--color-primary-hover)' },
              }}
            >
              {t('CLOSE')}
            </Button>
          </div>
        </div>
      </div>
    </ReactModal>
  )
}

export default DaysOffModal
